import { createTracker } from 'usage-tracker-public';
import { getUuid, resetAmplitudeStorageIfNeeded } from '../utils';
export default {
  init: options => createTracker(options),
  switch: (from, {
    location,
    replace
  }) => {
    if (from === undefined || from === 'anonymous') {
      const searchParams = new URLSearchParams(location.search);
      const currentUuid = getUuid(location); // If an UUID is present on the localStorage then we
      // need to erase the UUID from the Query Params
      // and do any necessary/possible cleanup

      if (currentUuid !== undefined) {
        resetAmplitudeStorageIfNeeded(currentUuid);
        searchParams.delete('uuid');
        replace(`${location.pathname}?${searchParams}`);
      }
    }
  }
};